/** @jsxImportSource @emotion/react */

import { listSocial } from "contants/listSocial";

import { SocialBoxStyle } from "./style.index";

export const SocialBox = () => {
  const renderSocial = listSocial.map((itemSocial, indexSocial) => {
    const openWindow = () => {
      if (itemSocial.id !== "cskh") return;

      window.open(itemSocial.url);
    };
    const isCheckPhone = itemSocial.id !== "phone";
    return (
      <div
        key={`key-${indexSocial}-social`}
        css={SocialBoxStyle.blockItem(isCheckPhone)}
        onClick={() => openWindow()}
      >
        <img src={itemSocial.picture} alt="" css={SocialBoxStyle.image} />
        <div css={SocialBoxStyle.blockContent}>
          <span>{itemSocial.title}</span>
          <span>{itemSocial.content}</span>
        </div>
      </div>
    );
  });
  return (
    <div css={SocialBoxStyle.container}>
      <div css={SocialBoxStyle.blockList}>{renderSocial}</div>
    </div>
  );
};
